import React from 'react';
import { Box, Typography } from '@mui/material';
import { fmtSum } from '../../utils';

// ─── ChartTooltip (суммы) ─────────────────────────────────────────────────────

/**
 * Кастомный тултип для графиков сумм (₸).
 */
export const ChartTooltip = ({ active, payload, label }: any) => {
  if (!active || !payload?.length) return null;
  return (
    <Box sx={{
      bgcolor: '#1e293b', color: 'white',
      px: 2, py: 1.5, borderRadius: 2,
      boxShadow: '0 8px 24px rgba(0,0,0,0.3)', minWidth: 160,
    }}>
      <Typography sx={{ fontSize: '0.78rem', color: '#94a3b8', mb: 0.5 }}>{label}</Typography>
      {payload.map((p: any, i: number) => (
        <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.25 }}>
          <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: p.color ?? p.stroke, flexShrink: 0 }} />
          <Typography sx={{ fontSize: '0.82rem', fontWeight: 600 }}>
            {p.name}: {typeof p.value === 'number' ? fmtSum(p.value) : p.value}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

// ─── QtyTooltip (количество) ──────────────────────────────────────────────────

/**
 * Кастомный тултип для графиков количества (уп.).
 */
export const QtyTooltip = ({ active, payload, label }: any) => {
  if (!active || !payload?.length) return null;
  return (
    <Box sx={{
      bgcolor: '#1e293b', color: 'white',
      px: 2, py: 1.5, borderRadius: 2,
      boxShadow: '0 8px 24px rgba(0,0,0,0.3)', minWidth: 140,
    }}>
      <Typography sx={{ fontSize: '0.78rem', color: '#94a3b8', mb: 0.5 }}>{label}</Typography>
      {payload.map((p: any, i: number) => (
        <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.25 }}>
          <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: p.color ?? p.stroke, flexShrink: 0 }} />
          <Typography sx={{ fontSize: '0.82rem', fontWeight: 600 }}>
            {p.name}: {p.value?.toLocaleString('ru-RU')} уп.
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

// ─── PieTooltip ───────────────────────────────────────────────────────────────

/**
 * Кастомный тултип для круговой диаграммы аптек.
 */
export const PieTooltip = ({ active, payload }: any) => {
  if (!active || !payload?.length) return null;
  const { name, value, percent } = payload[0];
  return (
    <Box sx={{
      bgcolor: '#1e293b', color: 'white',
      px: 2, py: 1.5, borderRadius: 2,
      boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
    }}>
      <Typography sx={{ fontSize: '0.82rem', fontWeight: 700 }}>Аптека №{name}</Typography>
      <Typography sx={{ fontSize: '0.82rem' }}>{fmtSum(value)}</Typography>
      <Typography sx={{ fontSize: '0.75rem', color: '#94a3b8' }}>
        {(percent * 100).toFixed(1)}% от итога
      </Typography>
    </Box>
  );
};
